module.exports = __webpack_public_path__ + "static/media/veneto-village-14.5c548100.jpg";